import React from 'react';
import { Link } from 'react-router-dom';

const SummaryStatCard = ({ title, variant, icon, count, link }) => {
  const tile = (
    <div className={`dash-stat-tile dash-tile-${variant}`}>
      <div className="dash-stat-label">{title}</div>
      <div className="dash-stat-value">{count}</div>
      <div className="dash-stat-icon">
        <i className={icon}></i>
      </div>
    </div>
  );

  return (
    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
      {link ? <Link to={link}>{tile}</Link> : tile}
    </div>
  );
};

export default SummaryStatCard;
